import { usePropertyStartedSiteWork } from '../../../../queries/PropertyFields/NonRentalLandFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';

interface PerformingSiteWorkProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const PerformingSiteWork: React.FC<PerformingSiteWorkProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Have you started performing any site work?';
    const [startedSiteWork, set_startedSiteWork] = usePropertyStartedSiteWork(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_startedSiteWork(true);
                return;
            case 'no':
                set_startedSiteWork(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={startedSiteWork ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='startedSiteWork'
                    value={startedSiteWork}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='Started Site Work required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
